import React, { useState } from 'react'

import { Box, Grid, Paper, Tab, Tabs, Typography } from '@material-ui/core'
import { isEmpty } from 'lodash'
import { useParams } from 'react-router-dom'

import { LoadingFeedback } from 'components'
import { QuestionCard, SkeletonPage } from './components'

import useFetch from 'hooks/useFetch'

import * as service from 'service'

import useStyles from './styles'

const ShowQuestionnaires = () => {
  const [selectedTab, setSelectedTab] = useState(0)
  const [downloading, setDownloading] = useState(false)

  const { companySupplierId, companySupplierAuditId } = useParams()
  const classes = useStyles()

  const { response, isLoading } = useFetch(
    service.dponet.suppliers.questionnaires.get,
    { companySupplierId, companySupplierAuditId },
  )

  const companySupplierQuestionnaires =
    response?.data?.companySupplierQuestionnaires || []

  const selectedItem = companySupplierQuestionnaires[selectedTab] || {}
  const quizQuestionTemplates = selectedItem?.quizQuestionTemplates || []

  return (
    <Box width="100%">
      <LoadingFeedback open={downloading} />
      <Paper component={Box} p={3} className={classes.scrollContainer}>
        {isLoading ? (
          <SkeletonPage />
        ) : (
          <Grid container spacing={3}>
            {isEmpty(companySupplierQuestionnaires) ? (
              <Grid item xs={12}>
                <Typography variant="body2" color="textSecondary">
                  Nenhum questionário encontrado
                </Typography>
              </Grid>
            ) : (
              <Grid item xs={12}>
                <Tabs
                  value={selectedTab}
                  onChange={(_, value) => setSelectedTab(value)}
                  indicatorColor="primary"
                  textColor="primary"
                  variant="scrollable"
                  scrollButtons="auto"
                >
                  {companySupplierQuestionnaires.map((item, index) => (
                    <Tab
                      key={item?.id ?? index}
                      label={item?.questionnaire?.kind}
                    />
                  ))}
                </Tabs>

                <Box mt={3}>
                  {isEmpty(quizQuestionTemplates) ? (
                    <Typography variant="body2" color="textSecondary">
                      Nenhuma pergunta encontrada
                    </Typography>
                  ) : (
                    <Grid container spacing={2}>
                      {quizQuestionTemplates.map((template, index) => (
                        <Grid item xs={12} key={template?.id ?? index}>
                          <QuestionCard
                            template={template}
                            setDownloading={setDownloading}
                          />
                        </Grid>
                      ))}
                    </Grid>
                  )}
                </Box>
              </Grid>
            )}
          </Grid>
        )}
      </Paper>
    </Box>
  )
}

export default ShowQuestionnaires
